import { render, staticRenderFns } from "./VendorProfile.vue?vue&type=template&id=d79f576a&scoped=true&"
import script from "./VendorProfile.vue?vue&type=script&lang=js&"
export * from "./VendorProfile.vue?vue&type=script&lang=js&"
import style0 from "./VendorProfile.vue?vue&type=style&index=0&id=d79f576a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79f576a",
  null
  
)

export default component.exports